import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "title", "items"]

  open(event) {
    const name  = event.currentTarget.dataset.gdprTemplateModalNameParam
    const items = JSON.parse(event.currentTarget.dataset.gdprTemplateModalItemsParam || "[]")

    this.titleTarget.textContent = name
    this.itemsTarget.innerHTML = items.map((label, i) => `
      <label class="flex items-center gap-3 p-2 rounded hover:bg-slate-50 cursor-pointer">
        <input type="checkbox"
               class="w-4 h-4 rounded border-gray-300 text-ps-orange focus:ring-ps-orange"
               ${i === 0 ? "checked" : ""}>
        <span class="text-sm text-gray-700">${this.escape(label)}</span>
      </label>
    `).join("")

    this.modalTarget.classList.remove("hidden")
  }

  // Labels come from editor-entered titles; injected as innerHTML they must be text, not markup.
  escape(value) {
    const div = document.createElement("div")
    div.textContent = String(value ?? "")
    return div.innerHTML
  }

  close() {
    this.modalTarget.classList.add("hidden")
  }
}
